/* global filestack */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TintForm = (props) => {
  const {
    filestackApiKey,
    onFileUploaded,
  } = props;

  if (! filestackApiKey) {
    // no API key supplied.
    return '';
  }

  const [filestackClient, setfilestackClient] = useState(null);

  if (! filestackClient) {
    // instantiate the filestack client.
    setfilestackClient(filestack.init(filestackApiKey));
    return '';
  }

  const [isUploading, setisUploading] = useState(false);
  const [finishedUploading, setfinishedUploading] = useState(false);

  const [filestackPicker, setfilestackPicker] = useState(null);

  if (! filestackPicker) {
    // instantiate the filestack picker.
    const options = {
      accept: [
        // mime types that we accept.
        'image/*',
        'video/*',
      ],
      fromSources: [
        'local_file_system',
      ],
      onFileSelected: (file) => {
        console.log({file}); // eslint-disable-line
      },
      onUploadStarted: () => {
        setisUploading(true);
      },
      onUploadDone: (files) => {
        setisUploading(false);
        if (0 < files.filesUploaded.length) {
          setfinishedUploading(true);
          onFileUploaded(files.filesUploaded[0]);
        }
      },
    };

    setfilestackPicker(filestackClient.picker(options));
  }

  let button = '';

  if (isUploading) {
    button = <button disabled type="button">Uploading..</button>;
  } else if (finishedUploading) {
    button = <button disabled type="button">File Uploaded!</button>;
  } else {
    button = (
      <button
        onClick={(e) => {
          e.preventDefault();
          filestackPicker.open();
        }}
        type="button"
      >
        Choose File
      </button>
    );
  }

  return button;
};

TintForm.defaultProps = {
  filestackApiKey: '',
};

TintForm.propTypes = {
  filestackApiKey: PropTypes.string,
  onFileUploaded: PropTypes.func.isRequired,
};

export default TintForm;
